import { centroid, polygon as createPolygon } from "@turf/turf";
import type { XY } from "@designboticteam/core";
import { toClosedPolygon } from "@designboticteam/kolega-3d";

/**
 * Computes the centroid of a polygon on the x/z plane using Turf.js.
 */
function getCentroid(polygon: Array<XY>): XY | null {
	const ring = toClosedPolygon(polygon);

	if (ring === null) {
		return null;
	}

	const c = centroid(createPolygon([ring]));
	const [x, y] = c.geometry.coordinates;

	return [x, y];
}

export { getCentroid };
